import React from 'react';
import ServicesHero from '../components/service_components/ServicesHero';
// import ServicesOverview from '../components/service_components/ServicesOverview';

import ServiceCards from '../components/service_components/ServiceCards';
import ServicesCTA from '../components/service_components/ServicesCTA';
import FeaturedServices from '../components/service_components/FeaturedServices';


const Services = () => {
  return (
    <div className="services-page">
      <ServicesHero />
      <FeaturedServices />
      <ServiceCards />
      <ServicesCTA />
    </div>
  );
};

export default Services;